import axios from "../../axios";
const url = "/media";

const state = {
  list: [],
  pagination: {
    current_page: 1,
    per_page: 9,
    total: 0,
  },
};

const actions = {
  async getList({ commit }, payload) {
    const response = await axios.get(url, { params: payload });
    if (response.status === 200) {
      commit("SET_LIST_MEDIA", response.data.data);
    }
    return response;
  },

  async update({ commit }, { id, payload }) {
    const response = await axios.put(url + "/" + id, payload);
    if (response.status === 200) {
      commit("UPDATE", response.data.data);
    }
    return response;
  },

  // eslint-disable-next-line no-unused-vars
  async updateCustomProperties({ commit }, { id, payload }) {
    return new Promise((resolve, reject) => {
      axios
        .put(`${url}/${id}/custom-properties`, payload)
        .then((response) => {
          if (response.status === 200) {
            commit("UPDATE", response.data.data);
          }
          resolve(response);
        })
        .catch((error) => {
          reject(error);
        });
    });
  },

  // eslint-disable-next-line no-unused-vars
  async cutVideo({ commit }, payload) {
    const response = await axios.post(url + "/cut-video", payload);
    return response;
  },

  // eslint-disable-next-line no-unused-vars
  async changeFileName({ commit }, { id, payload }) {
    const response = await axios.put(
      url + "/" + id + "/change-file-name",
      payload
    );
    return response;
  },

  /**
   * set current page
   * @param commit
   * @param data
   */
  setCurrentPage({ commit }, data) {
    commit("SET_CURRENT_PAGE", data);
  },

  /**
   * set per page
   * @param commit
   * @param data
   */
  setPerPage({ commit }, data) {
    commit("SET_PER_PAGE", data);
  },
};

const mutations = {
  SET_LIST_MEDIA(state, data) {
    state.list = data.data;
    state.pagination = data.pagination;
  },

  SET_CURRENT_PAGE(state, data) {
    state.pagination.current_page = data;
  },

  SET_PER_PAGE(state, data) {
    state.pagination.per_page = data;
  },

  UPDATE(state, media) {
    const index = state.list.findIndex((el) => el.id === media.id);

    if (index >= 0) {
      state.list.splice(index, 1, media);
    }
  },
};

const getters = {};

export default {
  namespaced: true,
  state,
  mutations,
  actions,
  getters,
};
